var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { PureComponent, createElement } from 'react';
import { Modal as AntModal } from 'antd';
import { ComponentsManager } from '@comall-backend-builder/core';
import { extendsParentProps } from '../component-props';
import PropTypes from 'prop-types';

var Modal = function (_super) {
  __extends(Modal, _super);

  function Modal(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      visible: false
    };
    _this.handleOkClick = _this.handleOkClick.bind(_this);
    _this.handleCancelClick = _this.handleCancelClick.bind(_this);
    _this.handleTriggerClick = _this.handleTriggerClick.bind(_this);
    return _this;
  }
  /**
   * 通过点击事件来触发弹层
   */


  Modal.prototype.handleTriggerClick = function () {
    this.setState({
      visible: true
    });
  };
  /**
   * 确认按钮的点击事件
   */


  Modal.prototype.handleOkClick = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, onConfirm, formSubmit, result;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.props, onConfirm = _a.onConfirm, formSubmit = _a.formSubmit;
            result = true;
            if (!(formSubmit && this.listenRef)) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this.listenRef.handleSubmit()];

          case 1:
            result = _b.sent();
            _b.label = 2;

          case 2:
            if (result) {
              this.setState({
                visible: false
              });
              onConfirm && onConfirm();
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 取消按钮的点击事件
   */


  Modal.prototype.handleCancelClick = function () {
    var onCancel = this.props.onCancel;
    this.setState({
      visible: false
    });

    if (onCancel) {
      onCancel();
    }
  };

  Modal.prototype.render = function () {
    var _a = this.props,
        title = _a.title,
        okText = _a.okText,
        cancelText = _a.cancelText,
        mask = _a.mask,
        maskClosable = _a.maskClosable,
        width = _a.width,
        className = _a.className,
        style = _a.style,
        zIndex = _a.zIndex;
    var props = {
      title: title,
      okText: okText,
      cancelText: cancelText,
      mask: mask,
      maskClosable: maskClosable,
      width: width,
      wrapClassName: className,
      style: style,
      zIndex: zIndex,
      visible: this.state.visible,
      onOk: this.handleOkClick,
      onCancel: this.handleCancelClick
    };
    var triggerComponent = this.renderTrigger();
    var modalComponent = React.createElement(AntModal, __assign({}, props), this.renderContent());
    return React.createElement("div", null, triggerComponent, modalComponent);
  };
  /**
   * 渲染响应触发弹层事件的组件
   */


  Modal.prototype.renderTrigger = function () {
    var props = this.props.triggerComponent;
    Object.assign(props, {
      onClick: this.handleTriggerClick
    });
    return this.renderComponent(props);
  };
  /**
   * 渲染弹层内部显示的组件
   */


  Modal.prototype.renderContent = function () {
    var _this = this;

    var props = this.props.content;

    if (this.props.formSubmit) {
      Object.assign(props, {
        wrappedComponentRef: function wrappedComponentRef(ref) {
          return _this.listenRef = ref;
        }
      });
    }

    return this.renderComponent(props);
  };
  /**
   * 渲染组件的方法
   * @param {object} componentProps 所要渲染组件的props
   */


  Modal.prototype.renderComponent = function (componentProps) {
    var component = componentProps.component,
        otherProps = __rest(componentProps, ["component"]);

    var props = extendsParentProps(__assign({}, otherProps), this.props);
    return createElement(ComponentsManager.get(component), props);
  };

  Modal.propTypes = {
    // 确认按钮处理的函数
    onConfirm: PropTypes.func,
    // 取消按钮处理的函数
    onCancel: PropTypes.func,
    // 弹层的标题
    title: PropTypes.string,
    // 用来触发弹层的组件
    triggerComponent: PropTypes.object,
    // 弹层内显示的组件
    content: PropTypes.object,
    // 点击确认按钮是否执行提交表单操作
    formSubmit: PropTypes.bool,
    // 自定义确认按钮的显示文字内容
    okText: PropTypes.string,
    // 自定义取消按钮的显示文字内容
    cancelText: PropTypes.string,
    // 自定义底部内容
    footer: PropTypes.arrayOf(PropTypes.object),
    // 是否显示遮罩
    mask: PropTypes.bool,
    // 点击蒙层是否允许关闭
    maskClosable: PropTypes.bool,
    // 弹层窗体的宽度
    width: PropTypes.string,
    // Modal 的 z-index
    zIndex: PropTypes.number
  };
  return Modal;
}(PureComponent);

export { Modal };